import React from 'react';
import Categories from './parts/categories.component';
import Mails from './parts/mails.component';
import { Container } from './settings.styles';

const Settings = props => {
  return <Container>
    <Categories />
    <Mails />
  </Container>;
};

export default Settings;
